__turbopack_context__.v({
  "community-header": "community-header-module-scss-module__TkwT5a__community-header",
  "join-button": "community-header-module-scss-module__TkwT5a__join-button",
  "promise": "community-header-module-scss-module__TkwT5a__promise",
  "text-block": "community-header-module-scss-module__TkwT5a__text-block",
  "title": "community-header-module-scss-module__TkwT5a__title",
});
